import { useQuery } from '@tanstack/react-query';
import { api } from './api.ts';

export interface DeptLite { id: string; name: string; code?: string | null; parentId?: string | null }
export const fetchDepartments = () => api<DeptLite[]>('/org/departments');
/** 활성 부서 전체(트리 정렬). 부서 선택 select 는 사용자 디렉터리가 아니라 이것을 쓴다 — 소속 인원이 없는 부서도 골라야 한다 */
export function useDepartments() { const q = useQuery({ queryKey: ['departments'], queryFn: fetchDepartments }); return { ...q, depts: q.data ?? [] }; }
